<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.5237 11.2006L19.4811 4.41931H18.0699L12.8949 10.3062L8.7648 4.41931H4L10.2469 13.3222L4 20.4326H5.4112L10.8725 14.2145L15.2352 20.4326H20M5.92053 5.46144H8.08853L18.0688 19.4417H15.9003"
            fill="inherit"
        />
    </svg>
</template>
